import { Requireable } from 'react';

import PropTypes, { ValidationMap } from 'prop-types';

import { omitKeys, optionalPropType } from '@adsk/alloy-react-helpers';
import Tooltip from '@adsk/alloy-react-tooltip';

import { PERMISSION_INDICATOR_PILL_TYPES } from '../consts';
import { Permission } from '../types';

export const pillValuePropType = optionalPropType(
  PropTypes.objectOf(
    PropTypes.oneOf(Object.values(PERMISSION_INDICATOR_PILL_TYPES)).isRequired,
  ),
);

const shape = {
  /**
   * Label of the permission to be displayed in the dropdown and in the Permission Indicator
   */
  label: PropTypes.node.isRequired,
  /**
   * Required for the permission option.
   * Optional for group item (if the item has a `options` props).
   */
  value: optionalPropType(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  /**
   * pill value to render a specific pill inside PermissionIndicator.
   *
   * Use Object for new permission like { 0: PILL_TYPES.SEMI, 1: PILL_TYPES.FULL }.
   */
  pillValue: pillValuePropType,
  /**
   * Whether the permission option should be disabled
   */
  disabled: optionalPropType(PropTypes.bool),
  /**
   * Tooltip content to display for permission option.
   */
  tooltip: PropTypes.any,
  /**
   * Props for the Tooltip content to display for permission option.
   */
  tooltipProps: optionalPropType(
    PropTypes.shape(
      omitKeys(Tooltip.propTypes, ['children']) as ValidationMap<
        typeof Tooltip.propTypes
      >,
    ),
  ),
};

export const permissionShape: Requireable<Permission> = PropTypes.shape({
  ...shape,
  options: optionalPropType(
    PropTypes.arrayOf(PropTypes.shape(shape).isRequired),
  ),
});

export const itemShape = PropTypes.shape({
  ...shape,
  /**
   * Whether current item is a group title item
   */
  isGroupTitle: optionalPropType(PropTypes.bool),
});

export const optionShape = PropTypes.shape({
  ...shape,
  /**
   * The label for the group item
   */
  groupLabel: PropTypes.node,
});
